export { default } from './Company'
export * from './Company'



// WEBPACK FOOTER //
// ./src/components/Company/index.ts